document.addEventListener('DOMContentLoaded', () => {
  // Smooth scroll for anchor links
  document.querySelectorAll('a[href^="#"]').forEach(anchor => {
    anchor.addEventListener('click', function (e) {
      e.preventDefault();
      document.querySelector(this.getAttribute('href')).scrollIntoView({
        behavior: 'smooth'
      });
    });
  });

  // Intersection Observer for fade-in animations
  const observerOptions = {
    root: null,
    rootMargin: '0px',
    threshold: 0.15
  };

  const observer = new IntersectionObserver((entries, observer) => {
    entries.forEach(entry => {
      if (entry.isIntersecting) {
        entry.target.classList.add('visible');
        observer.unobserve(entry.target);
      }
    });
  }, observerOptions);

  document.querySelectorAll('.fade-in').forEach(el => {
    observer.observe(el);
  });

  // --- Shopify Integration Logic ---

  // Homepage: Render Products
  const productGrid = document.getElementById('product-grid');
  if (productGrid && typeof fetchProducts === 'function') {
    // Show loading state or use mock fallback if token isn't set
    if (STOREFRONT_ACCESS_TOKEN === 'YOUR_STOREFRONT_API_TOKEN_HERE') {
      productGrid.innerHTML = `
        <div class="product-card"><p class="product-price">Waiting for Shopify API Token...</p></div>
      `;
    } else {
      fetchProducts(3).then(products => {
        if (!products || products.length === 0) {
          productGrid.innerHTML = '<p class="text-center w-100">No products found.</p>';
          return;
        }

        const html = products.map(product => {
          const price = product.priceRange.minVariantPrice;
          const imgUrl = product.images.edges[0] ? product.images.edges[0].node.url : 'assets/visual_break_1777479285046.png';
          
          return `
            <a href="product.html?handle=${product.handle}" class="product-card fade-in visible">
              <div class="product-image-container">
                <img src="${imgUrl}" alt="${product.title}" class="product-image">
              </div>
              <h3 class="product-name">${product.title}</h3>
              <p class="product-price">${price.currencyCode} ${price.amount}</p>
            </a>
          `;
        }).join('');
        
        productGrid.innerHTML = html;
      });
    }
  }

  // Product Page: Fetch Single Product and Setup Cart
  const productInfoContainer = document.querySelector('.product-info-sticky');
  if (productInfoContainer && typeof fetchProductByHandle === 'function') {
    const urlParams = new URLSearchParams(window.location.search);
    const handle = urlParams.get('handle');

    if (handle && STOREFRONT_ACCESS_TOKEN !== 'YOUR_STOREFRONT_API_TOKEN_HERE') {
      fetchProductByHandle(handle).then(product => {
        if (!product) return;

        // Update DOM with actual product details
        document.querySelector('.product-page-title').textContent = product.title;
        document.title = `${product.title} | PhantomSoul`;
        
        const price = product.priceRange.minVariantPrice;
        document.querySelector('.product-page-price').textContent = `${price.currencyCode} ${price.amount}`;
        
        // Setup variants
        const variants = product.variants.edges;
        if (variants.length > 0) {
          const sizeOptionsContainer = document.querySelector('.size-options');
          sizeOptionsContainer.innerHTML = variants.map((v, i) => `
            <div class="size-option ${i === 0 ? 'selected' : ''}" data-variant-id="${v.node.id}">
              ${v.node.title}
            </div>
          `).join('');

          // Re-bind click events for new dynamic size options
          const newSizeOptions = document.querySelectorAll('.size-option');
          newSizeOptions.forEach(option => {
            option.addEventListener('click', () => {
              newSizeOptions.forEach(opt => opt.classList.remove('selected'));
              option.classList.add('selected');
            });
          });
        }

        // Setup gallery images
        const gallery = document.querySelector('.product-gallery');
        gallery.innerHTML = product.images.edges.map(img => `
          <img src="${img.node.url}" alt="${img.node.altText || product.title}">
        `).join('');
        
        // Update description
        document.querySelector('.product-page-desc').innerHTML = product.descriptionHtml;
        
        // Add to Cart Logic
        const realAddToCartBtn = document.querySelector('.add-to-cart');
        realAddToCartBtn.addEventListener('click', async () => {
          const selectedVariant = document.querySelector('.size-option.selected');
          if (!selectedVariant) return;
          
          const variantId = selectedVariant.getAttribute('data-variant-id');
          
          realAddToCartBtn.textContent = 'Redirecting to Checkout...';
          const checkoutUrl = await createCartAndCheckout(variantId);
          if (checkoutUrl) {
            window.location.href = checkoutUrl;
          } else {
            realAddToCartBtn.textContent = 'Error. Try Again.';
            setTimeout(() => { realAddToCartBtn.textContent = 'Add to Cart'; }, 2000);
          }
        });
      });
    } else {
      // Mock logic if no token provided or no handle
      const addToCartBtn = document.querySelector('.add-to-cart');
      if (addToCartBtn) {
        addToCartBtn.addEventListener('click', () => {
          addToCartBtn.textContent = 'Adding...';
          setTimeout(() => {
            addToCartBtn.textContent = 'Added to Cart (Mock)';
            addToCartBtn.style.background = '#333';
            setTimeout(() => {
              addToCartBtn.textContent = 'Add to Cart';
              addToCartBtn.style.background = 'var(--text-primary)';
            }, 2000);
          }, 800);
        });
      }
    }
  } else if (!productInfoContainer) {
      // Basic CTA mock if not on product page
      const addToCartBtn = document.querySelector('.add-to-cart');
      if (addToCartBtn) {
        addToCartBtn.addEventListener('click', () => {
          addToCartBtn.textContent = 'Adding...';
          setTimeout(() => {
            addToCartBtn.textContent = 'Added to Cart';
            addToCartBtn.style.background = '#333';
            setTimeout(() => {
              addToCartBtn.textContent = 'Add to Cart';
              addToCartBtn.style.background = 'var(--text-primary)';
            }, 2000);
          }, 800);
        });
      }
  }
});
